<template>
    <div>
        <navbar :hideNavLogins="false"></navbar>
        <div class="container is-fullheight hero-body">
            <div class="columns is-centered">
                <div class="column is-12">
                    <book-details ref="book"></book-details>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "./features/Navbar"
import BookDetails from "./features/CreateBook/BookDetails"

export default {
    name: 'BookDetailsPage',
    components: {
        Navbar,
        BookDetails,
    },
    data() {
        return {

        }
    },
    mounted() {
        
    },
    methods: {
        test() {
            console.log(this.$refs.book)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BookDetailsPage.vue